module.exports = __webpack_public_path__ + "img/20241017-161801.2c3a550d.png";